import api from './api';

export const mediaService = {
  uploadMedia: async (formData) => {
    const response = await api.post('/media/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  deleteMedia: async (type, filename) => {
    const response = await api.delete(`/media/${type}/${filename}`);
    return response.data;
  },

  addMediaToFestival: async (festivalId, formData) => {
    const response = await api.post(`/media/festival/${festivalId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  removeMediaFromFestival: async (festivalId, type, filename) => {
    const response = await api.delete(`/media/festival/${festivalId}/${type}/${filename}`);
    return response.data;
  }
};
